<template>
  <BaseCard
    ref="card"
    :noPadding="true"
    clickable
    @click="openNews(newsinfo.url)"
  >
    <template #body>
      <div class="news-card">
        <img class="news-image" :src="url+'/image.png'">
        <div class="info-col">
          <h4>{{ newsinfo.title }}</h4>
          <p>{{ newsinfo.description }}</p>
        </div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from '@/components/BaseCard.vue';
import {
  onMounted, ref,
} from 'vue';

const props = defineProps({ url: String });
const newsinfo = ref({});

onMounted(() => {
  GetInfo();
});

async function GetInfo() {
  // Cache-bust so updated S3 content is picked up immediately (matches NewsList.vue).
  const response = await fetch(`${props.url}/data.json?cacheBust=${Date.now()}`, { cache: "no-store" });
  newsinfo.value = await response.json();
}

function openNews(url) {
  // open in new tab
  window.open(url, "_blank");
}

</script>

<style lang="scss" scoped>

.news-card {
  min-height: 132px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.news-image {
  width: 128px;
  object-fit: cover;
  object-position: center;
}

.info-col {
  padding: 10px;
  display: flex;
  flex-direction: column;
}

h4 {
  &:hover {
    text-decoration: underline;
  }
  &:focus, &:focus-visible {
    text-decoration: underline;
  }
}

p {
  font-size: small;
  font-style: italic;
  color: var(--body-text-color-secondary);
}

</style>
